import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Carousel } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { animationValues, transitionValues } from "../../utils/pageTransitions";
import { connect } from "react-redux";
import {
  get_settings,
  pause_suppliers_signup,
  resume_suppliers_signup,
} from "../../redux/actions/adminActions";
import AllSuppliers from "./suppliers/allSuppliers";
import Orders from "./suppliers/transactions/orders";
import Payments from "./suppliers/transactions/payments";
import AwaitingApproval from "./suppliers/awaitingApproval";
import Reports from "./suppliers/transactions/reports";
import Products from "./suppliers/transactions/products";
import CreateSupplierModal from "../modals/createSupplierModal";
import Spinner from "../reusables/spinner";
import DeletedSupplier from "./suppliers/deletedSupplier";

function Suppliers({
  pauseSupplierSignup,
  supplierSignup,
  resumeSupplierSignup,
  accessToken,
  getSettings,
  settings,
}) {
  const [index, setIndex] = useState(0);
  const [supplier, setSupplier] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(0);

  const nextSlide = (id, supplier) => {
    if (id != 0) setSelectedSupplier(id);
    setSupplier(supplier);
    setIndex(index + 1);
  };

  const isDone = () => {
    getSettings(accessToken, () => setLoading(false));
  };

  const clickHandler = () => {
    setLoading(true);
    if (supplierSignup === true) {
      pauseSupplierSignup(accessToken, () => isDone());
    } else {
      resumeSupplierSignup(accessToken, () => isDone());
    }
  };

  const [create, setCreate] = useState(false);

  const handleTabChange = (status) => {
    // setLoading(true);
    // dispatch(getOrders({ token, status, success: () => setLoading(false) }));
  };

  useEffect(() => {
    getSettings(accessToken, () => setLoading(false));
  }, [accessToken]);

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="container-fluid suppliers">
        <Carousel activeIndex={index} indicators={false} controls={false}>
          <Carousel.Item>
            <div className="spaceBetween mobileBlock">
              <h2 className="sectionText--big textIsBold">
                Supplier Managment
              </h2>

              <div className="textIsBold mobileAlign pt-2 d-flex">
                <button
                  className={`${
                    settings?.pause_suppliers_sign_up == 0
                      ? "btn__dark"
                      : "btn__gray"
                  } hasRadius d-flex`}
                  onClick={clickHandler}
                >
                  {settings?.pause_suppliers_sign_up == 0
                    ? "Pause Supplier Sign-up"
                    : "Resume Supplier Sign-up"}
                  {isLoading && <Spinner />}
                </button>
                <button
                  className="btn__filled hasRadius mx-2"
                  onClick={() => setCreate(true)}
                >
                  Add/Register Supplier
                </button>
              </div>
            </div>

            <Tabs className="pt-3">
              <TabList className="alignOnly sectionText--mid p-0">
                <Tab className="tabHead">Suppliers</Tab>
                <Tab className="tabHead">Awaiting Approval</Tab>
                <Tab className="tabHead">Deleted Suppliers</Tab>
              </TabList>

              <TabPanel>
                <AllSuppliers next={(e, supplier) => nextSlide(e, supplier)} />
              </TabPanel>
              <TabPanel>
                <AwaitingApproval />
              </TabPanel>
              <TabPanel>
                <DeletedSupplier />
              </TabPanel>
            </Tabs>
          </Carousel.Item>

          <Carousel.Item>
            <div className="">
              <h2
                className="sectionText--mid textIsBold isClickable alignOnly"
                onClick={() => setIndex(0)}
              >
                <i class="ri-arrow-left-line mx-2"></i>
                {supplier}
              </h2>

              <Tabs className="pt-3">
                <TabList className="alignOnly sectionText textIsGray">
                  <Tab className="tabHead">Orders</Tab>
                  <Tab className="tabHead">Payments</Tab>
                  <Tab className="tabHead">Reports</Tab>
                  <Tab className="tabHead">Products</Tab>
                </TabList>

                <TabPanel>
                  <Orders selected={selectedSupplier} />
                </TabPanel>
                <TabPanel>
                  <Payments selected={selectedSupplier} />
                </TabPanel>
                <TabPanel>
                  <Reports selected={selectedSupplier} />
                </TabPanel>
                <TabPanel>
                  <Products selected={selectedSupplier} />
                </TabPanel>
              </Tabs>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>

      <CreateSupplierModal show={create} handleClose={() => setCreate(false)} />
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  settings: state.admin.settings,
  supplierSignup: state.admin.supplierSignup,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getSettings: (token, success) => dispatch(get_settings(token, success)),
  pauseSupplierSignup: (token, success) =>
    dispatch(pause_suppliers_signup(token, success)),
  resumeSupplierSignup: (token, success) =>
    dispatch(resume_suppliers_signup(token, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Suppliers);
